export function getProductCodesDescription(
  product_codes: readonly string[],
): string {
  return product_codes.reduce((result, code, index) => {
    if (index === 0) {
      return `${code}`;
    }
    return `${result}+${code}`;
  }, '');
}
